// extracted by mini-css-extract-plugin
module.exports = {"configurableGrid":"styles_configurableGrid__3XU52","topPanel":"styles_topPanel__1CqJN","bottomPanel":"styles_bottomPanel__2omsr"};